var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Types from './types';
import { normalizeFontFamily } from '../../util/fonts';
var initialState = {
    theme: {
        logo: '',
        fontFamily: normalizeFontFamily('Roboto'),
        primaryColor: '#6A67F6',
        backgroundColor: '#FFFFFF',
        primaryTextColor: '#002251',
        secondaryTextColor: '#7A869A',
        buttonContentColor: '#FFFFFF',
        inputBackgroundColor: '#F2F4F7',
        inputLabelColor: '#C1C7D0',
        inputTextColor: '#002251',
        inputPlaceholderColor: '#757575',
        defaultTheme: true
    },
};
var reducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case Types.UPDATE_THEME:
            if (action.theme) {
                return __assign(__assign({}, state), { theme: __assign(__assign({}, action.theme), { fontFamily: normalizeFontFamily(action.theme.fontFamily) }) });
            }
            return __assign({}, state);
    }
    return state;
};
export default reducer;
